export const lenisRef = { current: null };

export const PHONE = "980-251-4838";
export const TEL = "tel:+19802514838";
export const SMS = "sms:+19802514838";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const NAV = [
  { id: "services", label: "Services" },
  { id: "owners", label: "Property Owners" },
  { id: "quote", label: "Get a Quote" },
  { id: "retrieval", label: "Got Towed?" },
  { id: "faq", label: "FAQ" },
];

export const AREAS = [
  "Uptown", "South End", "NoDa", "Plaza Midwood", "University City",
  "Ballantyne", "SouthPark", "Steele Creek", "Dilworth", "West End",
];

export const LOT = {
  street: "2708 Midland Ave",
  city: "Charlotte, NC 28208",
  mapEmbed: "https://www.google.com/maps?q=2708+Midland+Ave,+Charlotte,+NC+28208&output=embed",
  directions: "https://www.google.com/maps/dir/?api=1&destination=2708+Midland+Ave,+Charlotte,+NC+28208",
};

export const EASE = [0.16, 1, 0.3, 1];
